import type { ReactNode } from 'react';
import { Line, LineChart } from 'recharts';

import { ChartContainer, type ChartConfig } from '../../ui/chart';

export type Trend = 'up' | 'down' | 'flat';

const toneColor: Record<Trend, string> = {
  up: 'var(--primary-ink)',
  down: 'var(--destructive)',
  flat: 'var(--muted-foreground)',
};

// No token expresses this box size; recharts' `ResponsiveContainer` also needs
// it as its pre-measurement `initialDimension`, so one constant drives both.
const DIMENSION = { width: 110, height: 30 };

export function Sparkline(props: {
  values: readonly number[];
  tone: Trend;
  label: string;
}): ReactNode {
  const data = props.values.map((value, index) => ({ index, value }));
  const config = {
    value: { label: props.label, color: toneColor[props.tone] },
  } satisfies ChartConfig;

  return (
    <ChartContainer
      config={config}
      role="img"
      aria-label={props.label}
      initialDimension={DIMENSION}
      style={DIMENSION}
      className="aspect-auto"
    >
      <LineChart data={data} accessibilityLayer={false}>
        <Line
          dataKey="value"
          stroke="var(--color-value)"
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ChartContainer>
  );
}
